// removed by extract-text-webpack-plugin
module.exports = {"this":"_3Ug410bl532PfOgMDRgSjN","mintIndicatorWrapper":"_1nuszgCP_L0AF8f-W0kn_F","mintIndicatorText":"_3Kc0vAdqjAYo2zs2XRsDvZ","shade":"_3NvQc4ygfijocjh7otvzhi"};


//////////////////
// WEBPACK FOOTER
// ./src/frame/ui/popup/Loading.scss
// module id = 610
// module chunks = 12